import { buildModelManager } from "../builder.js";
const DefaultWhatsappRuleSelection = {
  __typename: true,
  id: true,
  actionParameters: true,
  actionType: true,
  campaignId: true,
  createdAt: true,
  customerId: true,
  eventParameters: true,
  eventReplyButtonId: true,
  eventType: true,
  isScenarioTrigger: true,
  scenarioId: true,
  updatedAt: true,
  waitingTimeInSeconds: true,
  whatsappTemplateId: true
};
const modelApiIdentifier = "whatsappRule";
const pluralModelApiIdentifier = "whatsappRules";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWhatsappRuleSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWhatsappRuleSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappRuleSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappRuleSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappRuleSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappRuleSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappRuleSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createWhatsappRule",
    operationReturnType: "CreateWhatsappRule",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      whatsappRule: { required: false, type: "CreateWhatsappRuleInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappRuleSelection
  },
  {
    type: "action",
    operationName: "bulkCreateWhatsappRules",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateWhatsappRulesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWhatsappRuleSelection
  },
  {
    type: "action",
    operationName: "updateWhatsappRule",
    operationReturnType: "UpdateWhatsappRule",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      whatsappRule: { required: false, type: "UpdateWhatsappRuleInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappRuleSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateWhatsappRules",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateWhatsappRulesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWhatsappRuleSelection
  },
  {
    type: "action",
    operationName: "deleteWhatsappRule",
    operationReturnType: "DeleteWhatsappRule",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteWhatsappRules",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertWhatsappRule",
    operationReturnType: "UpsertWhatsappRule",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      whatsappRule: { required: false, type: "UpsertWhatsappRuleInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateWhatsappRuleResult": { hasReturnType: false },
      "... on UpdateWhatsappRuleResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappRuleSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertWhatsappRules",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertWhatsappRulesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultWhatsappRuleSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "whatsappRuleGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const WhatsappRuleManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultWhatsappRuleSelection,
  operations
);
export {
  DefaultWhatsappRuleSelection,
  WhatsappRuleManager
};
//# sourceMappingURL=WhatsappRule.js.map
